export const PNSTopics: Map<string, string> = new Map<string, string>([
    ['pns:permissions', 'Engagement Permission'],
    ['pns:task:transportation', 'Transportation'],
    ['pns:permissions:rx', 'Rx Permission'],
]);

